var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var StyleObjectBuilder = /** @class */ (function () {
    function StyleObjectBuilder(styleObject, themeVariation) {
        this.styleObject = styleObject;
        this.themeVariation = themeVariation;
    }
    StyleObjectBuilder.prototype.withStyleResolver = function (styleResolver) {
        var styleObject = styleResolver(this.themeVariation);
        this.baseStyle = __assign(__assign({}, this.baseStyle), styleObject);
        return this;
    };
    StyleObjectBuilder.prototype.withOptionalStyle = function (styleObject, enabledResolver) {
        if (!enabledResolver(this.themeVariation)) {
            return this;
        }
        this.baseStyle = __assign(__assign({}, this.baseStyle), styleObject);
        return this;
    };
    StyleObjectBuilder.prototype.withWebStyle = function (webStyle, disabled) {
        if (disabled) {
            return this;
        }
        this.webStyle = __assign(__assign({}, this.webStyle), webStyle);
        return this;
    };
    StyleObjectBuilder.prototype.withNativeStyle = function (_nativeStyle, _disabled) {
        return this;
    };
    StyleObjectBuilder.prototype.withBaseStyle = function (baseStyle) {
        this.baseStyle = baseStyle;
        return this;
    };
    StyleObjectBuilder.prototype.withCustomStyle = function (customStyle) {
        this.customStyle = customStyle;
        return this;
    };
    StyleObjectBuilder.prototype.build = function () {
        return __assign(__assign(__assign(__assign({}, this.baseStyle), this.webStyle), this.styleObject), this.customStyle);
    };
    return StyleObjectBuilder;
}());
export default StyleObjectBuilder;
//# sourceMappingURL=StyleObjectBuilder.js.map